<template>
  <div>
    <div>
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">{{ $t("service.add_edit_service[0]") }}</h3>
        </div>

        <form
          class="form-horizontal"
          id="addEditLocation"
          @submit="submit($event)"
        >
          <div class="box-body">
            <div class="form-group required">
              <label for="serviceName" class="col-sm-3 control-label">{{
                $t("service.add_edit_service[1]")
              }}</label>

              <div class="col-sm-6">
                <input
                  v-model="serviceName"
                  type="text"
                  class="form-control"
                  id="serviceName"
                  :placeholder="$t('service.add_edit_service[1]')"
                  @input="validate_serviceName"
                />
                <span v-if="serviceNameStatus == false" class="help is-danger">
                  <font color="red">{{ $t(error_msg.serviceNameSmg) }}</font>
                </span>
              </div>
            </div>

            <!-- start fee group -->
            <div class="form-group required">
              <label class="col-sm-3 control-label">{{
                $t("service.feegroup")
              }}</label>
              <div class="col-sm-6">
                <select
                  v-model="feeGroupSelected"
                  class="form-control"
                  style="width: 100%;"
                  @change="changeFeeGroup"
                >
                  <option
                    v-for="index in serviceFeeGroup"
                    :key="index.id"
                    class="form-control"
                    :value="index.id"
                    >{{ $t(index.name) }}</option
                  >
                </select>
                <span v-if="feeGroupStatus == false" class="help is-danger">
                  <font color="red">{{ $t(error_msg.feeGroupSmg) }}</font>
                </span>
              </div>
            </div>
            <!-- end fee group -->

            <div class="form-group required">
              <label class="col-sm-3 control-label">{{
                $t("service.add_edit_service[2]")
              }}</label>
              <div class="col-sm-6">
                <select
                  v-model="serviceTypeSelected"
                  class="form-control"
                  style="width: 100%;"
                  @change="validate_serviceType"
                  :disabled="id != 0"
                >
                  <option
                    v-for="serviceTypeValue in serviceTypeList"
                    v-bind:key="serviceTypeValue.id"
                    class="form-control"
                    v-bind:value="serviceTypeValue.id"
                    >{{ serviceTypeValue.name }}</option
                  >
                </select>
                <span v-if="serviceTypeStatus == false" class="help is-danger">
                  <font color="red">{{ $t(error_msg.serviceTypeSmg) }}</font>
                </span>
              </div>
            </div>
            <div class="form-group">
              <label for="serviceCode" class="col-sm-3 control-label">{{
                $t("service.add_edit_service[3]")
              }}</label>

              <div class="col-sm-6">
                <input
                  v-model="serviceCode"
                  type="text"
                  class="form-control"
                  id="serviceCode"
                  disabled
                />
              </div>
            </div>
            <div class="form-group">
              <label for="serviceCategory" class="col-sm-3 control-label">{{
                $t("service.add_edit_service[4]")
              }}</label>

              <div class="col-sm-6">
                <input
                  v-model="serviceCategory"
                  type="text"
                  class="form-control"
                  id="serviceCategory"
                  :placeholder="$t('service.add_edit_service[4]')"
                />
              </div>
            </div>
            <div class="form-group" v-if="!feeRangeType">
              <label for="serviceFree" class="col-sm-3 control-label"
                >{{ $t("service.add_edit_service[7]") }} ?</label
              >

              <div class="col-sm-6">
                <input
                  class="col-lg-1 col-md-4 col-sm-4 control-label"
                  type="checkbox"
                  v-model="serviceFree"
                />
              </div>
            </div>
            <div class="form-group required">
              <label for="servicePrice" class="col-sm-3 control-label">{{
                $t(serviceFeeLabel)
              }}</label>

              <div class="col-sm-6">
                <input
                  v-model="servicePrice"
                  type="text"
                  class="form-control"
                  id="servicePrice"
                  :placeholder="$t(serviceFeeLabel)"
                  :disabled="serviceFree"
                  @change="onServicePriceChange"
                  @input="validate_servicePrice"
                />
                <span v-if="servicePriceStatus == false" class="help is-danger">
                  <font color="red">{{ $t(error_msg.servicePriceSmg) }}</font>
                </span>
              </div>
            </div>
            <!-- start VAT -->
            <div class="form-group">
              <label for="vat" class="col-sm-3 control-label">{{
                $t(serviceVATLabel)
              }}</label>
              <div class="col-sm-6">
                <input
                  v-model="serviceVAT"
                  type="number"
                  class="form-control"
                  id="serviceVAT"
                  :placeholder="$t(serviceVATLabel)"
                  @change="onServiceVATChange"
                  @input="validate_serviceVAT"
                />
                <span v-if="serviceVATStatus == false" class="help is-danger">
                  <font color="red">{{ $t(error_msg.serviceVATSmg) }}</font>
                </span>
              </div>
            </div>
          </div>

          <div class="box-footer">
            <button
              type="button"
              class="btn btn-labeled btn-danger"
              style="margin-right: 5px; background-color: #f29911;border-color: #f29911;"
              @click="cancel"
            >
              <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
              {{ $t("service.addeditservice_btn[0]") }}
            </button>
            <button
              v-if="
                (parseInt(this.id) !== 0 && has_perm('update_service')) ||
                  GET_ACCOUNT_DATA.id == 1
              "
              type="button"
              class="btn btn-labeled btn-success pull-right"
              @click="submit"
              style="margin-right: 5px;"
            >
              <span class="btn-label">
                <i class="glyphicon glyphicon-ok"></i>
              </span>
              {{ $t("service.addeditservice_btn[2]") }}
            </button>
            <button
              v-else-if="
                (parseInt(this.id) == 0 && has_perm('create_service')) ||
                  has_perm('update_service') ||
                  GET_ACCOUNT_DATA.id == 1
              "
              type="button"
              class="btn btn-labeled btn-success pull-right"
              @click="submit"
              style="margin-right: 5px;"
            >
              <span class="btn-label">
                <i class="glyphicon glyphicon-ok"></i>
              </span>
              {{ $t("service.addeditservice_btn[2]") }}
            </button>
          </div>
        </form>
      </div>
    </div>
    <router-view></router-view>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
  </div>
</template>
<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";
//import VueTimepicker from "vue2-timepicker";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';

export default {
  name: "ServiceAddEdit",
  data() {
    return {
      id: 0,
      actionType: "",
      serviceName: "",
      serviceTypeId: "",
      serviceTypeName: "",
      servicePrice: 0,
      serviceVAT: 0,
      servicePriceFact: {},
      businessHour: "",
      serviceProviderName: "CONASI",
      serviceProviderAddress: "Ho Chi Minh City",
      serviceTypeList: [],
      businessHourList: [
        { id: 1, name: "service.time_range[0]", selected: false },
        { id: 2, name: "service.time_range[1]", selected: false },
        { id: 3, name: "service.time_range[2]", selected: false },
        { id: 4, name: "service.time_range[3]", selected: true }
      ],
      serviceTypeSelected: 11,
      priceInputs: [
        {
          min: 0,
          max: null,
          price: 0
        }
      ],
      feeRangeType: false,
      businessList: [],
      workingHour: [
        {
          id: 1,
          name: "service.calendar[0]",
          start_time: { HH: "09", mm: "00" },
          end_time: { HH: "18", mm: "00" },
          selected: true
        },
        {
          id: 2,
          name: "service.calendar[1]",
          start_time: { HH: "09", mm: "00" },
          end_time: { HH: "18", mm: "00" },
          selected: true
        },
        {
          id: 3,
          name: "service.calendar[2]",
          start_time: { HH: "09", mm: "00" },
          end_time: { HH: "18", mm: "00" },
          selected: true
        },
        {
          id: 4,
          name: "service.calendar[3]",
          start_time: { HH: "09", mm: "00" },
          end_time: { HH: "18", mm: "00" },
          selected: true
        },
        {
          id: 5,
          name: "service.calendar[4]",
          start_time: { HH: "09", mm: "00" },
          end_time: { HH: "18", mm: "00" },
          selected: true
        },
        {
          id: 6,
          name: "service.calendar[5]",
          start_time: { HH: "09", mm: "00" },
          end_time: { HH: "18", mm: "00" },
          selected: true
        },
        {
          id: 7,
          name: "service.calendar[6]",
          start_time: { HH: "09", mm: "00" },
          end_time: { HH: "18", mm: "00" },
          selected: true
        }
      ],
      businessHourSelected: null,
      dayCheckbox: false,
      formatedTime: "HH",
      timeChoosen: [],
      serviceCategory: null,
      serviceCode: null,
      serviceFree: false,
      tempPrice: 0,
      serviceFeeLabel: "service.add_edit_service[9]",
      serviceVATLabel: "service.add_edit_service[12]",
      serviceFeeGroup: [
        { id: 1, name: "service.service_btn[1]" },
        { id: 2, name: "service.service_btn[2]" }
        // { id: 3, name: 'service.service_btn[3]' },
        // { id: 4, name: 'service.service_btn[4]' },
        // { id: 5, name: 'service.service_btn[5]' }
      ],
      feeGroupSelected: 1,
      isLoading: false,
      error_msg: {
        serviceNameSmg: "",
        feeGroupSmg: "",
        serviceTypeSmg: "",
        serviceProviderNameSmg: "",
        serviceProviderAddressSmg: "",
        servicePriceSmg: "",
        serviceVATSmg: ""
      },
      serviceNameStatus: true,
      feeGroupStatus: true,
      serviceTypeStatus: true,
      serviceProviderNameStatus: true,
      serviceProviderAddressStatus: true,
      servicePriceStatus: true,
      serviceVATStatus: true,
    };
  },

  watch: {
    SERVICE_DETAILS: function() {
      this.id = this.SERVICE_DETAILS.id;
      this.serviceName = this.SERVICE_DETAILS.name;
      this.serviceTypeSelected = this.SERVICE_DETAILS.serviceTypeId;
      let prices = this.SERVICE_DETAILS.servicePrice;
      this.serviceVAT = this.SERVICE_DETAILS.serviceVAT;
      this.servicePrice = prices[0].fee_value;
      this.tempPrice = this.servicePrice;
      this.servicePrice = this.formatBeautiNumber(
        parseInt(this.servicePrice),
        "VND",
        0
      );
      let workingHours_result = [];
      this.SERVICE_DETAILS.serviceBusinessHour.forEach(v => {
        let name;
        if (v.service_day_week == 1) {
          name = "service.calendar[0]";
        } else if (v.service_day_week == 2) {
          name = "service.calendar[1]";
        } else if (v.service_day_week == 3) {
          name = "service.calendar[2]";
        } else if (v.service_day_week == 4) {
          name = "service.calendar[3]";
        } else if (v.service_day_week == 5) {
          name = "service.calendar[4]";
        } else if (v.service_day_week == 6) {
          name = "service.calendar[5]";
        } else if (v.service_day_week == 7) {
          name = "service.calendar[6]";
        }
        let data = {
          id: v.service_day_week,
          name: name,
          start_time: {
            HH: v.working_hour_start.split(":")[0],
            mm: v.working_hour_start.split(":")[1]
          },
          end_time: {
            HH: v.working_hour_end.split(":")[0],
            mm: v.working_hour_end.split(":")[1]
          },
          selected: v.active
        };
        workingHours_result.push(data);
      });
      this.workingHour = workingHours_result;
      this.serviceProviderName = this.SERVICE_DETAILS.serviceProviderName;
      this.serviceProviderAddress = this.SERVICE_DETAILS.serviceProviderAddress;
      this.serviceCategory = this.SERVICE_DETAILS.serviceCategory;
      this.serviceCode = this.SERVICE_DETAILS.serviceCode;
      this.serviceFree = this.SERVICE_DETAILS.serviceFree;
      this.feeGroupSelected = this.SERVICE_DETAILS.feeGroupId;
    },
    SERVICE_TYPE_LIST: function() {
      this.serviceTypeList = this.SERVICE_TYPE_LIST;
    },
    businessHourSelected: function() {
      if (this.businessHourSelected.id !== 4) {
        this.workingHour = this.fillstatictbusinesshour(
          this.businessHourSelected
        );
      }
    },
    serviceFree: function() {
      if (this.serviceFree === true) {
        this.servicePrice = 0 + " VND";
      } else {
        this.servicePrice = this.tempPrice;
      }
    }
  },

  computed: {
    ...mapGetters([
      "SERVICE_DETAILS",
      "SERVICE_TYPE_LIST",
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA"
    ])
  },
  created() {
    this.GET_SERVICE_TYPE_LIST();
    this.id = this.$route.params.id;
    if (parseInt(this.id) !== 0) {
      this.actionType = "Edit";
      this.GET_SERVICE_DETAILS({ id: this.id });
      this.businessHourSelected = this.businessHourList[3];
    } else {
      this.actionType = "Add";
      this.businessHourSelected = this.businessHourList[0];
    }
  },

  methods: {
    ...mapActions([
      "GET_SERVICE_DETAILS",
      "ADD_SERVICE",
      "UPDATE_SERVICE",
      "GET_SERVICE_TYPE_LIST",
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "ON_SHOW_TOAST"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    formatBeautiNumber: function(num, suffix, decimal) {
      let value = num
        .toFixed(Math.max(0, ~~decimal))
        .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
      return `${value}`; //`${value} ${suffix}`;
    },
    validate_serviceName: function() {
      this.error_msg.serviceNameSmg = "";
      this.serviceNameStatus = true;
      if (this.serviceName == null || this.serviceName == "") {
        this.error_msg.serviceNameSmg = "common.error_msg[0].required";
        this.serviceNameStatus = false;
      }
      return this.serviceNameStatus;
    },
    validate_feeGroup: function() {
      this.error_msg.feeGroupSmg = "";
      this.feeGroupStatus = true;
      if (this.feeGroupSelected == null) {
        this.error_msg.feeGroupSmg = "common.error_msg[0].required";
        this.feeGroupStatus = false;
      }
      return this.feeGroupStatus;
    },
    validate_serviceType: function() {
      this.error_msg.serviceTypeSmg = "";
      this.serviceTypeStatus = true;
      if (this.serviceTypeSelected == null) {
        this.error_msg.serviceTypeSmg = "common.error_msg[0].required";
        this.serviceTypeStatus = false;
      }
      return this.serviceTypeStatus;
    },
    validate_serviceProviderName: function() {
      this.error_msg.serviceProviderNameSmg = "";
      this.serviceProviderNameStatus = true;
      if (this.serviceProviderName == null || this.serviceProviderName == "") {
        this.error_msg.serviceProviderNameSmg = "common.error_msg[0].required";
        this.serviceProviderNameStatus = false;
      }
      return this.serviceProviderNameStatus;
    },
    validate_serviceProviderAddress: function() {
      this.error_msg.serviceProviderAddressSmg = "";
      this.serviceProviderAddressStatus = true;
      if (
        this.serviceProviderAddress == null ||
        this.serviceProviderAddress == ""
      ) {
        this.error_msg.serviceProviderAddressSmg =
          "common.error_msg[0].required";
        this.serviceProviderAddressStatus = false;
      }
      return this.serviceProviderAddressStatus;
    },
    validate_servicePrice: function() {
      this.error_msg.servicePriceSmg = "";
      this.servicePriceStatus = true;
      if (this.servicePrice == null || this.servicePrice == "") {
        this.error_msg.servicePriceSmg = "common.error_msg[0].required";
        this.servicePriceStatus = false;
      }
      return this.servicePriceStatus;
    },
    validate_serviceVAT: function() {
      this.error_msg.serviceVATSmg = "";
      this.serviceVATStatus = true;
      if (this.serviceVAT === null || this.serviceVAT === "") {
        this.error_msg.serviceVATSmg = "common.error_msg[0].required";
        this.serviceVATStatus = false;
      } else if (
        parseInt(this.serviceVAT) < 0 ||
        parseInt(this.serviceVAT) > 100
      ) {
        this.error_msg.serviceVATSmg =
          "common.error_msg[1].vat_incorrect_format";
        this.serviceVATStatus = false;
      }
      return this.serviceVATStatus;
    },
    changeFeeGroup: function() {
      if (this.feeGroupSelected == 1) {
        this.serviceFeeLabel = "service.servicefeelabel[1]";
      } else if (this.feeGroupSelected == 2) {
        this.serviceFeeLabel = "service.servicefeelabel[2]";
      } else if (this.feeGroupSelected == 3) {
        this.serviceFeeLabel = "service.servicefeelabel[3]";
      } else if (this.feeGroupSelected == 4) {
        this.serviceFeeLabel = "service.servicefeelabel[4]";
      } else if (this.feeGroupSelected == 5) {
        this.serviceFeeLabel = "service.servicefeelabel[5]";
      } else {
        this.serviceFeeLabel = "service.servicefeelabel[0]";
      }
      this.validate_feeGroup();
    },
    onServicePriceChange: function() {
      this.tempPrice = this.servicePrice;
      let decimal = 0;
      // let suffix = ""//"VND";
      let number = parseInt(this.servicePrice);
      let value = number
        .toFixed(Math.max(0, ~~decimal))
        .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
      this.servicePrice = `${value}`; //`${value} ${suffix}`;
    },
    onServiceVATChange: function() {
      this.serviceVAT = `${this.serviceVAT}`;
    },
    onGetUsers() {
      this.$router.push({
        name: "UsersByService"
      });
    },
    fillstatictbusinesshour(option) {
      if (option.id === 1) {
        return [
          {
            id: 1,
            name: "service.calendar[0]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: true
          },
          {
            id: 2,
            name: "service.calendar[1]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: true
          },
          {
            id: 3,
            name: "service.calendar[2]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: true
          },
          {
            id: 4,
            name: "service.calendar[3]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: true
          },
          {
            id: 5,
            name: "service.calendar[4]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: true
          },
          {
            id: 6,
            name: "service.calendar[5]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: true
          },
          {
            id: 7,
            name: "service.calendar[6]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: true
          }
        ];
      } else if (option.id === 2) {
        return [
          {
            id: 1,
            name: "service.calendar[0]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: true
          },
          {
            id: 2,
            name: "service.calendar[1]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: true
          },
          {
            id: 3,
            name: "service.calendar[2]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: true
          },
          {
            id: 4,
            name: "service.calendar[3]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: true
          },
          {
            id: 5,
            name: "service.calendar[4]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: true
          },
          {
            id: 6,
            name: "service.calendar[5]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: false
          },
          {
            id: 7,
            name: "service.calendar[6]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: false
          }
        ];
      } else if (option.id === 3) {
        return [
          {
            id: 1,
            name: "service.calendar[0]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: false
          },
          {
            id: 2,
            name: "service.calendar[1]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: false
          },
          {
            id: 3,
            name: "service.calendar[2]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: false
          },
          {
            id: 4,
            name: "service.calendar[3]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: false
          },
          {
            id: 5,
            name: "service.calendar[4]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: false
          },
          {
            id: 6,
            name: "service.calendar[5]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: true
          },
          {
            id: 7,
            name: "service.calendar[6]",
            start_time: { HH: "09", mm: "00" },
            end_time: { HH: "18", mm: "00" },
            selected: true
          }
        ];
      }
    },
    addRow() {
      let current_value = this.priceInputs[this.priceInputs.length - 1].max;
      if (current_value === null) {
        alert("Please enter value first");
        return;
      }
      this.priceInputs.push({
        min: current_value,
        max: null
      });
    },
    deleteRow(index) {
      if (index === this.priceInputs.length - 1) {
        //
      } else {
        let previous_maxvalue = this.priceInputs[index - 1].max;
        this.priceInputs[index + 1].min = previous_maxvalue;
      }
      this.priceInputs.splice(index, 1);
    },
    cancel: function() {
      this.$router.push({ name: "ServiceList" });
    },
    checkForm: function() {
      let check_serviceName = this.validate_serviceName();
      let check_feeGroup = this.validate_feeGroup();
      let check_serviceType = this.validate_serviceType();
      let check_serviceProviderName = true;
      let check_serviceProviderAddress = true;
      let check_serivcePrice = this.validate_servicePrice();
      let check_serivceVAT = this.validate_serviceVAT();

      if (
        check_serviceName &&
        check_feeGroup &&
        check_serviceType &&
        check_serviceProviderName &&
        check_serviceProviderAddress &&
        check_serivcePrice &&
        check_serivceVAT
      ) {
        return true;
      } else {
        return false;
      }
    },
    submit: function(event) {
      event.preventDefault();
      let self = this;

      // Service Fee
      let serviceFee = [];

      let data = {
        fee_value: this.tempPrice, //this.servicePrice,
        fee_fact: {}
      };
      serviceFee.push(data);

      // Service Business Hour
      let serviceBusinessHour = [];
      this.workingHour.forEach(v => {
        let data = {
          service_day_week: v.id,
          working_hour_start: v.start_time.HH + ":" + v.start_time.mm,
          working_hour_end: v.end_time.HH + ":" + v.end_time.mm,
          active: v.selected
        };
        serviceBusinessHour.push(data);
      });

      if (this.checkForm()) {
        this.isLoading = true;
        if (parseInt(this.id) === 0) {
          let payload = {
            name: this.serviceName,
            serviceFeeGroup: this.feeGroupSelected,
            serviceType: this.serviceTypeSelected,
            servicePrice: serviceFee,
            // serviceProviderName: this.serviceProviderName,
            // serviceProviderAddress: this.serviceProviderAddress,
            //serviceBusinessHour: serviceBusinessHour,
            category: this.serviceCategory,
            serviceFree: this.serviceFree,
            serviceVAT: this.serviceVAT,

            user_created_id: this.GET_ACCOUNT_DATA.id,
            app: 1, // 1. CONASI Webadmin // 2. CONASI Mobile App
            action: 0 // 0. Tạo // 1. Sửa, cập nhật // 2. Xóa
          };
          this.ADD_SERVICE(payload)
            .then(
              function(res) {
                this.isLoading = false;
                // self.$router.push({name : 'ServiceList'})
                this.SUCCESS_TOAST();
                this.clearDataInput();
                self.$router.push({ name: "ServiceList" });
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false;
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        } else {
          let edit_data = {
            id: this.id,
            name: this.serviceName,
            serviceFeeGroup: this.feeGroupSelected,
            serviceType: this.serviceTypeSelected,
            servicePrice: serviceFee,
            // serviceProviderName: this.serviceProviderName,
            // serviceProviderAddress: this.serviceProviderAddress,
            // serviceBusinessHour: serviceBusinessHour,
            category: this.serviceCategory,
            serviceFree: this.serviceFree,
            serviceVAT: this.serviceVAT,

            user_created_id: this.GET_ACCOUNT_DATA.id,
            app: 1, // 1. CONASI Webadmin // 2. CONASI Mobile App
            action: 1 // 0. Tạo // 1. Sửa, cập nhật // 2. Xóa
          };

          this.UPDATE_SERVICE(edit_data)
            .then(
              function(res) {
                this.isLoading = false;
                this.clearDataInput();
                self.$router.push({ name: "ServiceList" });
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false;
                this.ERROR_TOAST();
              }.bind(this)
            );
        }
      }
    },
    clearDataInput: function() {
      this.serviceName = "";
      this.serviceProviderName = "";
      this.serviceProviderAddress = "";
      this.serviceTypeSelected = null;
      this.serviceCategory = null;
      this.serviceCode = null;
      this.serviceFree = false;
      this.servicePrice = "";
      this.feeGroupSelected = null;
    }
  },
  mounted() {
    const data = {
      params: {
        page: 1
      }
    };

    this.GET_SERVICE_TYPE_LIST(data);
    if (this.serviceFree === true) {
      this.servicePrice = 0;
    }
  },
  components: {
    //timepicker: VueTimepicker,
    loading: Loading,
    "lte-core-alert": LTECoreAlert
  }
};
</script>

<style scoped>

hr.style-one {
  border: 0;
  height: 1px;
  background: #333;
  background-image: -webkit-linear-gradient(left, #ccc, #333, #ccc);
  background-image: -moz-linear-gradient(left, #ccc, #333, #ccc);
  background-image: -ms-linear-gradient(left, #ccc, #333, #ccc);
  background-image: -o-linear-gradient(left, #ccc, #333, #ccc);
}
.form-group.required .control-label:after {
  color: #d00;
  position: absolute;
  margin-left: 8px;
  margin-top: -3px;
  font-family: "FontAwesome";
  font-weight: normal;
  font-size: 9px;
  content: "\f069";
}
</style>



// WEBPACK FOOTER //
// src/views/Service/ServiceAddEdit.vue